export default function SvgSpacer() {
    return <div style={{ background: "#daddec", height: "2px", margin: "0 12px", width: "44px" }}></div>;
}